import { render, staticRenderFns } from "./SearchDocument.vue?vue&type=template&id=6917f81c&"
import script from "./SearchDocument.vue?vue&type=script&lang=js&"
export * from "./SearchDocument.vue?vue&type=script&lang=js&"
import style0 from "./SearchDocument.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports